import { useState, useEffect } from 'react';

export const LANDING_REF_STORAGE_KEY = "landingRef";

interface LandingParams {
  company_name?: string;
  company_website?: string;
  selected_plan?: string;
}

/** Synchronous read of the marketing-site handoff.
 *
 *  The hook below resolves in an effect, so it is undefined on the first paint.
 *  Callers that must branch before anything renders — the `/` resolver decides
 *  between checkout and a company dashboard — need the value immediately. */
export const readLandingParams = (): LandingParams => {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(LANDING_REF_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as LandingParams) ?? {} : {};
  } catch {
    return {};
  }
};

export const useLandingParams = () => {
  const [landingParams, setLandingParams] = useState<LandingParams | null>(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("landingRef");
      if (raw) {
        const params = JSON.parse(raw);

        setLandingParams(params);
      }
    } catch {}
  }, []);

  return {
    companyName: landingParams?.company_name,
    companyUrl: landingParams?.company_website,
    selectedPlan: landingParams?.selected_plan,
  };
};
